<template>
  <ul class="nav nav-pills nav-justified patch-group-nav">
    <li
      v-for="(patchGroup, patchGroupIndex) in patchGroups"
      :key="patchGroupIndex"
      class="patch-group-nav__item"
    >
      <a
        href="#"
        class="patch-group-nav__item-link"
        @click.prevent="handlePatchGroupClicked(patchGroup)"
      >{{ patchGroup.Name }}</a>
    </li>
  </ul>
</template>

<script>
import GoogleAnalytics from '@Shared/lib/google-analytics'

export default {
  name: 'PatchGroupNav',
  props: {
    patchGroups: { type: Array, default: null, required: true }
  },
  methods: {
    handlePatchGroupClicked (patchGroup) {
      GoogleAnalytics.trackEvent(
        'Select Patch Modal Group Nav',
        'click',
        patchGroup.Name
      )

      this.$emit('patchg-group-clicked', patchGroup.Id)
    }
  }
}
</script>

<style lang="scss" scoped>
.patch-group-nav {
  background-color: #eee;
  margin-bottom: 20px;
  text-align: center;

  &__item {
    &-link {
      border-radius: 0;
      color: $letterjacket-color-blue;
      font-size: 16px;
      font-weight: 600;
      padding: 5px 0;
      text-decoration: underline;
      text-transform: uppercase;

      &:hover {
        color: purple;
        text-decoration: underline;
      }
    }

    &:last-of-type::after {
      content: "";
    }
  }

  @media screen and (min-width: $screen-sm-min) {
    &__item {
      &-link {
        font-size: 12px;
      }

      &::after {
        color: #757575;
        content: "|";
        font-size: 26px;
        position: absolute;
        right: 0;
        top: -5px;
      }
    }
  }

  @media screen and (min-width: $screen-lg-min) {
    &__item {
      &-link {
        font-size: 16px;
        padding: 20px 0;
      }

      &::after {
        font-size: 32px;
        top: 8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/SleevePatchSelection/SleevePatchSelectionModal/PatchGroupNav.vue